/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const unmarkedEmailsCountDataSchema = z.object({
	unmarkedCount: z.number(),
})

export type UnmarkedEmailsCountDataSchema = z.infer<typeof unmarkedEmailsCountDataSchema>
